module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_SLOE_W_VSL2100_VERTICALE.74bf8707.png";